import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { ContendientesService } from 'src/app/services/contendientes.service';

@Component({
  selector: 'app-navbar-dos',
  templateUrl: './navbar-dos.component.html',
  styleUrls: ['./navbar-dos.component.css']
})
export class NavbarDosComponent implements OnInit {
  public today: any;
  public leyendaSuperior: string="";
  
  fullTextString: any;
  loadingPosts: boolean = true;
  keyWord: any;
  contendientes: any;
  catalog: any;
  files: any;
  ActualizacionAl:string="";
  public config:any;

  constructor(private api: ContendientesService, private router: Router) { 
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };

    this.router.events.subscribe((evt) => {
      if (evt instanceof NavigationEnd) {
        this.configuracionSistema((evt.url=="/renuncias"));
      }
    });
  }

  ngOnInit(): void {
    this.today = this.formatAMPM();
    // this.configuracionSistema();
    this.getLeyendaSuperior();
  }
  
  getLeyendaSuperior() {
    this.api.getLeyendaSuperior().subscribe((rest:any)=>{
      let leySuperior = rest.data.getLeyendaSuperior;
      this.leyendaSuperior = leySuperior.LeyendaSuperior;
    });
  }
  configuracionSistema(renuncua:Boolean) {
    this.api
      .configuracionSistema()
      .subscribe((result) => {
        if(result)
        this.config=result;
        this.ActualizacionAl = (renuncua)?this.config.ActualizacionRenunciasAl:this.config.ActualizacionAl;
      });
  }
  buscarContendiente(termino: string) {
    this.router.navigate(['/buscadorb', termino]);
  }
  searchPosts(termino: string) {
    const keyWordFilter = this.fullTextString ? null : this.keyWord;
    this.loadingPosts = true;
    this.api
      .searchPosts(keyWordFilter, this.fullTextString, this.files, this.catalog)
      .refetch()
      .then((result) => {
        this.loadingPosts = false;
        return result.data && result.data.filter;
      });
  }
  formatAMPM(): string {
    const d = new Date();
    const months = [
      'de enero',
      'de febrero',
      'de marzo',
      'de abril',
      'de mayo',
      'de junio',
      'de julio',
      'de agosto',
      'de septiembre',
      'de octubre',
      'de noviembre',
      'de diciembre',
    ];
    const days = [
      'Domingo',
      'Lunes',
      'Martes',
      'Miércoles',
      'Jueves',
      'Viernes',
      'Sábado',
    ];
    return (
      days[d.getDay()] +
      ' ' +
      d.getDate() +
      ' ' +
      months[d.getMonth()] +
      ', ' +
      d.getFullYear()
    );
  }
}

